/** IDs estáticos de componentes compartilhados (kebab-case, padrão checkout). */
const SHARED_TEST_IDS = {
	LAYOUT_MAIN: 'layout-main',
	BASE_MODAL: 'base-modal',
	BASE_MODAL_CLOSE_BUTTON: 'base-modal-close-button',
	BASE_MODAL_FOOTER: 'base-modal-footer',
	CONFIRMATION_MODAL_CANCEL_BUTTON: 'confirmation-modal-cancel-button',
	CONFIRMATION_MODAL_CONFIRM_BUTTON: 'confirmation-modal-confirm-button',
	FEEDBACK_ACTION_BUTTON: 'feedback-action-button',
	FEEDBACK_SECONDARY_BUTTON: 'feedback-secondary-button',
	TOAST_PORTAL: 'toast-portal',
	TOAST: 'toast',
	TOAST_CLOSE_BUTTON: 'toast-close-button',
	TOAST_ACTION_BUTTON: 'toast-action-button',
	AUTH_LOADING_FALLBACK: 'auth-loading-fallback'
} as const;

const sharedTestId = {
	toast: (id: string) => `toast-${id}`,
	toastAction: (id: string) => `toast-action-button-${id}`,
	toastClose: (id: string) => `toast-close-button-${id}`
} as const;

export { SHARED_TEST_IDS, sharedTestId };
